import React from 'react';

import { MetricsDrawer } from '../styled';
import { ParametrsModalProps } from '../types';

const MetricsModal = ({ closeModal, open, children }: ParametrsModalProps) => {
  return (
    <MetricsDrawer
      open={open}
      anchor="bottom"
      onClose={closeModal}
      disableRestoreFocus
      closeAfterTransition
      disableEscapeKeyDown
    >
      {children}
    </MetricsDrawer>
  );
};

export default MetricsModal;
